import React, { useState } from 'react'
import { Image, StyleSheet } from 'react-native'

import { useQueryClient } from '@tanstack/react-query'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { B4, BottomSheet, Button, Select, Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'
import { changeLocaleInHeader } from '@zet/network'

import { IBrandComsData } from '../../../api/brands/types'
import LanguageChange from '../../../assets/svg/languageChange.svg'
import { EN, HI } from '../../../utils/constants'
import { Header } from './header'

const CardImage = ({ content }: { content: IBrandComsData | undefined }) => {
  const [isLanguageBottomsheetVisible, setIsLanguageBottomsheetVisible] =
    useState<boolean>(false)
  const store = useAddCustomerStore()
  const [selectedValue, setSelectedValue] = useState(
    i18n.locale === 'en' ? EN : HI
  )
  const queryClient = useQueryClient()
  function closeBottomsheet() {
    setIsLanguageBottomsheetVisible(false)
  }
  function openBottomsheet() {
    setIsLanguageBottomsheetVisible(true)
  }
  function onChangeSelect(value: string) {
    setSelectedValue(value)
  }
  function onSubmit() {
    if (selectedValue === EN) {
      store.setWebFlowLocale('en')
      i18n.locale = 'en'
      changeLocaleInHeader('en')
    } else {
      store.setWebFlowLocale('hi')
      i18n.locale = 'hi'
      changeLocaleInHeader('hi')
    }
    queryClient.invalidateQueries({
      queryKey: ['brandDetailsById'],
    })
    closeBottomsheet()
  }
  return (
    <Stack>
      <Image
        source={{
          uri: content?.productCardLink,
        }}
        resizeMode="cover"
        className="aspect-[3/2.4]"
      />
      <Pressable
        className="absolute right-3 top-3 flex-row items-center rounded-md px-3 py-1"
        onPress={openBottomsheet}
        style={styles.background}
      >
        <LanguageChange />
        <B4 className="text-neutral-white100 ml-2">
          {i18n.locale === 'en' ? EN : HI}
        </B4>
      </Pressable>
      <BottomSheet
        visible={isLanguageBottomsheetVisible}
        onDismiss={closeBottomsheet}
        snapPoints={[300, 300]}
      >
        <Header
          title={i18n.t('appLanguage.choose')}
          closeBottomSheet={closeBottomsheet}
        />
        <Stack className="mx-3 mt-3">
          <Select onChange={onChangeSelect} mode={'single'}>
            {[EN, HI].map((item, index) => (
              <Select.Option
                key={`${item}-${index}`}
                selectedValue={selectedValue}
                optionContainerStyle="h-14 w-full my-1 justify-center rounded-lg mb-2"
                optionTextStyle="pl-3 text-base font-[Graphie-SemiBold]"
                name={item}
                showToggle={true}
              >
                {item}
              </Select.Option>
            ))}
          </Select>
        </Stack>
        <Stack className="bg-neutral-white100 absolute bottom-0 w-full px-3 py-2">
          <Button
            className="bg-tertiary-200 w-full"
            size={'lg'}
            onPress={onSubmit}
          >
            {i18n.t('bottomView.continue')}
          </Button>
        </Stack>
      </BottomSheet>
    </Stack>
  )
}

export { CardImage }
const styles = StyleSheet.create({
  background: {
    backgroundColor: 'rgba(255, 255, 255, 0.18)',
  },
})
